export default function Chats() {
    // TODO: Implement this function
    return <h1>Chats</h1>
}